import { render } from "./AuthMain.vue?vue&type=template&id=054bab90"
import script from "./AuthMain.vue?vue&type=script&lang=js"
export * from "./AuthMain.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__